import { Component, Input, OnInit, Optional, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChatModule } from '../chat.module';
import { ChatService } from '../chat.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'chat-fullscreen',
  templateUrl: './chat-fullscreen.component.html',
  styleUrls: ['./chat-fullscreen.component.css'],
  standalone: true,
  imports: [
    ChatModule
],
})
export class ChatFullscreenComponent implements OnInit, OnDestroy {

  @Input() theme: 'blue' | 'grey' | 'red' = 'blue';
  carregando = true;

  private _destroy$: Subject<void> = new Subject<void>();

  constructor(
    private _chatService: ChatService,
    @Optional() private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.carregarIconsGoogle();

    this._chatService.chatLoaded$.pipe(
      takeUntil(this._destroy$)
    ).subscribe((value: boolean) => {
      if (value) {
        this.carregando = false;
      }
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  carregarIconsGoogle(): void {
    this.carregarStylesheet('https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp');
    this.carregarStylesheet('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');
  }

  private carregarStylesheet(href: string): void {
    if (document.head.querySelector(`link[href="${href}"]`) != null) {
      return;
    }
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }
}
